import layout from '../../internal/Layout.vue'
import page from './index.vue'
import managePage from './components/checklists/manage.vue'
import printPage from './components/checklists/print.vue'

const InspectionRoutineRoutes = {
  component: layout,
  children: [
    {
      name: 'inspectionRoutineChecklist',
      path: '/',
      component: page,
      meta: {
        module: 'checklist',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordSector: true,
        requiresCoordOp: true,
        requiresLaboratory: true,
      },
    },
    {
      name: 'manageInspectionRoutineChecklist',
      path: '/inspectionRoutineChecklist/manage',
      component: managePage,
      meta: {
        module: 'checklist',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordSector: false,
        requiresCoordOp: false,
        requiresLaboratory: true,
      },
    },
    {
      name: 'printInspectionRoutineChecklist',
      path: '/inspectionRoutineChecklist/print',
      component: printPage,
      meta: {
        module: 'checklist',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordSector: true,
        requiresCoordOp: true,
        requiresLaboratory: true,
      },
    },
  ],
}

export default InspectionRoutineRoutes
